import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";

import { CellComponentProps } from "../types";

type ApiKeysListItemCreatorCellProps = CellComponentProps;

const ApiKeysListItemCreatorCell = ({ apiKey }: ApiKeysListItemCreatorCellProps) => {
  return (
    <Box fullWidth gap="large">
      <TextEllipsis tooltip={apiKey.creator} tooltipWidthMode="maxWidthSm">
        {(props) => (
          <Typography {...props} tag="span" variant="p-body3">
            {apiKey.creator}
          </Typography>
        )}
      </TextEllipsis>
    </Box>
  );
};

export default ApiKeysListItemCreatorCell;
